import React, { useState } from 'react';
import { ChevronRight, Home } from 'lucide-react';

const BreadcrumbItem = ({ item, index, isLast, onNavigate, onDrop }) => {
    const [isDragOver, setIsDragOver] = useState(false);

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.dataTransfer.dropEffect = 'move';
        setIsDragOver(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(false);

        try {
            const dragData = JSON.parse(e.dataTransfer.getData('application/json'));

            if (onDrop) {
                onDrop(item.id, dragData.selectedFolders || [], dragData.selectedDocuments || []);
            }
        } catch (err) {
            console.error('Drop error:', err);
        }
    };

    return (
        <button
            onClick={() => onNavigate(item.id)}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            className={`pai-tap-row flex items-center gap-1.5 px-2 py-1 rounded-chip transition-colors whitespace-nowrap ${
                isDragOver
                    ? 'bg-pai-green/[0.12] text-pai-green'
                    : isLast
                        ? 'text-white font-semibold'
                        : 'text-white/50 hover:text-white hover:bg-white/[0.07]'
            }`}
        >
            {index === 0 && <Home size={16} className="flex-shrink-0" />}
            <span>{item.name}</span>
        </button>
    );
};

const FileManagerBreadcrumb = ({ breadcrumb, onNavigate, onDrop }) => {
    return (
        <div className="flex items-center px-6 pt-5 pb-1 overflow-x-auto">
            <nav className="flex items-center gap-1.5 text-[14px] font-medium">
                {breadcrumb.map((item, index) => (
                    <React.Fragment key={item.id || 'root'}>
                        {index > 0 && (
                            <ChevronRight size={14} className="text-white/25 flex-shrink-0" />
                        )}
                        <BreadcrumbItem
                            item={item}
                            index={index}
                            isLast={index === breadcrumb.length - 1}
                            onNavigate={onNavigate}
                            onDrop={onDrop}
                        />
                    </React.Fragment>
                ))}
            </nav>
        </div>
    );
};

export default FileManagerBreadcrumb;
